import styled from 'styled-components';
import { COLOR_BASE_GREY_40 } from '@audi/audi-ui-design-tokens';

export const HighlightWrap = styled.li`
  display: flex;
  overflow-x: auto;
`;
HighlightWrap.displayName = 'HighlightWrap';

export const CommonHighlight = styled.div`
  hyphens: auto;
  margin-bottom: var(${(props): string => props.theme.responsive.spacing.xl});
  max-width: 100%;
  overflow-wrap: break-word;

  .sc-detail-highlight-label {
    color: ${COLOR_BASE_GREY_40};
  }
`;
CommonHighlight.displayName = 'CommonHighlight';

export const SkeletonHighlight = styled(CommonHighlight)`
  width: 100%;
`;
SkeletonHighlight.displayName = 'SkeletonHighlight';
